import { getVisibleEntries } from '../../config/searchRegistry'
import type { AccessFlags } from '../../contexts/UserPermissionsContext'
import { canOpenResource, type Resource } from './model'
import { profileResources } from './profileResources'
import { buildShortcutCatalogue } from './shortcuts'

export function searchResources({ resources, knowledge, ready, accessFlags, documentsVisible }: {
  resources: Resource[]; knowledge: Resource[]; ready: boolean; accessFlags: AccessFlags; documentsVisible: boolean;
}, permissions: Record<string, any>, email: string, isOverride: boolean): Resource[] {
  const additional: Resource[] = ready ? getVisibleEntries({
    userPermissions: permissions, userEmail: email, documentsVisible,
    billsAccess: accessFlags.bills, wellbeingAllowanceAccess: accessFlags.wellbeingAllowance,
    duoServicesAccess: accessFlags.duoServices,
  }).filter(entry => entry.group === 'Admin' || entry.path === '/').map(entry => ({
    id: entry.path, path: entry.path, label: entry.label, keywords: entry.keywords,
    detail: entry.group === 'Admin' ? 'Administration' : 'Duo Hub',
    kind: 'Apps', searchCategory: entry.group, icon: entry.icon,
  })) : []
  const all = [
    ...(ready ? profileResources(String(permissions.Division_Location__c || ''), isOverride) : []),
    ...resources, ...knowledge, ...additional,
    ...buildShortcutCatalogue(resources, { groupKnowledge: false }).flatMap(shortcut => shortcut.actions),
  ]
  const seen = new Set<string>()
  return all.filter(resource => {
    if (seen.has(resource.path) || !canOpenResource(resource.path, accessFlags, documentsVisible)) return false
    seen.add(resource.path)
    return true
  })
}
